import { createApp } from 'vue';
import { createLogto } from '@logto/vue';
import App from './App.vue';
import { createAppRouter } from './router.ts';
import { logtoConfigFor } from './lib/auth.ts';
import { loadCopy } from './lib/copy.ts';
import { loadRuntimeConfig } from './lib/runtime.ts';

import '@jcao/ui/tokens.css';
import '@jcao/ui/components.css';

/*
 * First, and before the app exists: which Logto this deployment signs in
 * against is an argument to the plugin, and the published image does not know
 * it until it is running. See lib/runtime.ts.
 */
await loadRuntimeConfig();

const app = createApp(App);
app.use(createLogto, logtoConfigFor());

app.use(createAppRouter());

// Fetched before mount so the first paint uses the team's wording rather than
// flashing the shipped defaults and replacing them. If it fails, the defaults
// are already correct English and the app carries on.
await loadCopy();
app.mount('#app');
